import angular from 'angular';
import swoaSecurityService from './security.service';

export default angular
  .module('swoa.security', [
    swoaSecurityService,
  ])
  .name;
